/**
 * The old script editor route, `/pipeline/b/:ref/presentacion/guion`.
 *
 * Editing the script is a mode of the presentation page now (`?edit=1`), so
 * an old link, a bookmark or a notification lands there, in edit mode, and
 * the old address leaves the history.
 */
import { Navigate, useParams } from "react-router-dom";
import { scriptPath } from "@/features/storyboard/paths";

export function ScriptRedirect() {
  const { ref } = useParams();
  if (!ref) return <Navigate to="/pipeline" replace />;
  return <Navigate to={scriptPath(ref)} replace />;
}
